const AnalyticsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.44 7.88V6.61C19.44 6.27 19.17 6 18.83 6H13.11C12.77 6 12.5 6.27 12.5 6.61V7.88H19.44Z"
        fill="#57CC99"
      />
      <path d="M23.0498 20.79V22.04H8.87988V20.79H23.0498ZM24.1797 19.6602V9.63965C24.1795 9.01359 23.6728 8.50977 23.0498 8.50977H20.0322L20.042 8.5H8.87988C8.26381 8.50006 7.75019 9.00679 7.75 9.63965V19.6602C7.75008 20.2863 8.25692 20.79 8.87988 20.79V22.04L8.6377 22.0273C7.52044 21.9143 6.62693 21.0282 6.5127 19.9043L6.5 19.6602V9.63965C6.50019 8.31985 7.57005 7.25006 8.87988 7.25H23.0596L23.0498 7.25977C24.3597 7.25977 25.4295 8.31981 25.4297 9.63965V19.6602L25.418 19.9023C25.2968 21.0994 24.2874 22.04 23.0498 22.04V20.79C23.676 20.79 24.1796 20.2832 24.1797 19.6602Z" />
      <path d="M11.2441 21.7402L9.9043 26.79L8.69531 26.4697L10.0361 21.4199L11.2441 21.7402Z" />
      <path d="M23.2441 26.4697L22.0361 26.79L20.6953 21.7402L21.9043 21.4199L23.2441 26.4697Z" />
      <path
        d="M20.4351 11.5268C20.7076 11.2149 21.1817 11.1829 21.4937 11.4555C21.8052 11.728 21.8371 12.2013 21.5649 12.5131L17.5191 17.143L13.4712 15.1996L11.648 17.0815C11.3597 17.3789 10.8858 17.3863 10.5884 17.0981C10.2909 16.8098 10.2835 16.335 10.5718 16.0375L13.147 13.3803L17.1401 15.2963L20.4351 11.5268Z"
        fill="#57CC99"
      />
    </svg>
  );
};

export default AnalyticsIcon;
